export default "__VITE_ASSET__CLehgQ2C__"